import { badgeColorData } from '@/components/atom/Badge';
import { PushProgressStatus } from '@/src/models/PushAlarmInfoDto';
import { OPTIONS_CONST } from '@/src/constants/options';

export const getStatusBadgeProps = (
  type: PushProgressStatus,
): {
  children: string;
  badgeColor: keyof typeof badgeColorData;
} => {
  switch (type) {
    case 'scheduled':
      return {
        children: OPTIONS_CONST.pushScheduled,
        badgeColor: 'lightYellow',
      };
    case 'inProgress':
      return {
        children: OPTIONS_CONST.pushInProgress,
        badgeColor: 'lightGreen',
      };
    case 'completed':
      return {
        children: OPTIONS_CONST.pushCompleted,
        badgeColor: 'lightGray',
      };
    default:
      return {
        children: '-',
        badgeColor: 'lightGray',
      };
  }
};
